import React from 'react'
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "./Data/HolidayCRUDConfig.json";
import { Box } from "@mui/material";
import PageHeader from "../../components/PageHeader";

function HolidayPage() {
  return (
    <Box sx={{ display: "flex" }}>
    <Box sx={{ flexGrow: 1, marginTop:0, marginLeft: 15,  marginRight: 15, marginBottom:15}} >
    <PageHeader pageTitle="Manage Holiday " />
      <CrudManager
        data={schema}
        actionBtnName="Add Holiday "
        createFormTitle="Add Holiday"
        updateFormTitle="Update Holiday"
      />
    </Box>
  </Box>
  )
}

export default HolidayPage
